import { useEffect, useState } from "react";

/**
 * Custom hook to calculate and update the maximum height of Swiper slides.
 *
 * @param containerClass - The class name of the Swiper container to target slides within.
 * @param isLoading - A boolean indicating if the data is still loading.
 * @param dependencies - Dependencies for recalculating the slide heights.
 * @returns The maximum height of the slides or null if no slides are found.
 */
const useSlideHeight = (
  containerClass: string,
  isLoading?: boolean,
  dependencies: any[] = []
): number | null => {
  const [maxHeight, setMaxHeight] = useState<number | null>(null);

  useEffect(() => {
    const updateHeight = () => {
      if (isLoading) return;

      const slideHeights = Array.from(
        document.querySelectorAll(`.${containerClass} .swiper-slide`)
      ).map((slide) => (slide as HTMLElement).scrollHeight);

      setMaxHeight(slideHeights.length ? Math.max(...slideHeights) : 0);
    };

    if (!isLoading) {
      updateHeight();
    }

    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, [containerClass, isLoading, ...dependencies]);
  return maxHeight;
};

export default useSlideHeight;
